<template>
  <div
    v-bind="$attrs"
    class="text-caps color-brand_main"
    style="display: flex; align-items: center; gap: 0.5em; text-align: start"
  >
    <Logo style="height: 3em" />
    <div>
      Hobson <br />
      Bernardino
    </div>
  </div>
</template>

<script setup>
import Logo from "../components/Logo.vue";
</script>
